import {
  cloneElement,
  CSSProperties,
  FC,
  isValidElement,
  PropsWithChildren,
  ReactElement,
} from 'react';
import classNames from 'classnames';

import { ColorfulSectionWrapperProps } from './interfaces';

import useStyles from './style';

const ColorfulSectionWrapper: FC<PropsWithChildren<ColorfulSectionWrapperProps>> = ({
  headlineColors,
  children,
}) => {
  const classes = useStyles();

  const light =
    headlineColors?.customLightModeHeadlineColor || headlineColors?.defaultLightModeHeadlineColor;
  const dark =
    headlineColors?.customDarkModeHeadlineColor || headlineColors?.defaultDarkModeHeadlineColor;

  const styleVars = {
    '--section-light-color': light,
    '--section-dark-color': dark,
  } as CSSProperties;

  let content = children;

  if (isValidElement(children)) {
    content = cloneElement(children as ReactElement, {
      className: classNames(classes.colorfulSectionWrapper, children.props.className),
      style: { ...(children.props.style || {}), ...styleVars },
    });
  }

  return content;
};

export default ColorfulSectionWrapper;
